/**
 * @module Core
 */

import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EnsureModuleLoadedOnceGuard } from '@app/helpers/module-import.guard';
import { DynamicElementsContainerModule } from '@app/components/dynamic-elements-container/dynamic-elements-container.module';
import { PermissionModule } from '@app/services/permissions/permission.module';

/**
 * Core module for the application.
 *
 * This module serves as a singleton and provides core services and components
 * that are essential for the application. It extends the EnsureModuleLoadedOnceGuard
 * to prevent multiple imports of the same module.
 *
 * @extends {EnsureModuleLoadedOnceGuard}
 */
@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		DynamicElementsContainerModule, // Shall contain dynamic elements as tooltip, popup etc.
		PermissionModule,
	],
	exports: [],
	providers: [],
})
export class CoreModule extends EnsureModuleLoadedOnceGuard {
	/**
	 * Creates an instance of the CoreModule.
	 *
	 * @constructor
	 * @param {CoreModule} [parentModule] - The parent module that is being checked for multiple imports.
	 * @optional
	 * @skipSelf
	 */
	constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
		super(parentModule);
	}
}
